import React, { useState } from 'react';

const ProdukSection = () => {
  const [activeCategory, setActiveCategory] = useState('semua');

  const produk = [
    {
      id: 1,
      nama: 'Keripik Singkong',
      harga: 15000,
      deskripsi: 'Keripik singkong renyah dengan berbagai varian rasa original, pedas, dan balado',
      gambar: '/images/keripik-singkong.jpg',
      kategori: 'makanan',
      rating: 4.5,
      terjual: 120,
      badge: 'Terlaris'
    },
    {
      id: 2,
      nama: 'Madu Hutan Asli',
      harga: 75000,
      deskripsi: 'Madu hutan murni dari lebah liar dengan khasiat alami untuk kesehatan',
      gambar: '/images/madu-hutan.jpg',
      kategori: 'minuman',
      rating: 4.8,
      terjual: 85,
      badge: 'Premium'
    },
    {
      id: 3,
      nama: 'Kerajinan Anyaman Bambu',
      harga: 45000,
      deskripsi: 'Kerajinan tangan anyaman bambu dengan motif tradisional yang elegan',
      gambar: '/images/anyaman.jpg',
      kategori: 'kerajinan',
      rating: 4.3,
      terjual: 65
    },
    {
      id: 4,
      nama: 'Kopi Arabika Premium',
      harga: 35000,
      deskripsi: 'Kopi arabika khas desa dengan cita rasa premium dan aroma yang khas',
      gambar: '/images/kopi.jpg',
      kategori: 'minuman',
      rating: 4.7,
      terjual: 95,
      badge: 'Baru'
    },
    {
      id: 5,
      nama: 'Dodol Garut',
      harga: 25000,
      deskripsi: 'Dodol tradisional dengan tekstur lembut dan rasa manis yang pas',
      gambar: '/images/dodol.jpg',
      kategori: 'makanan',
      rating: 4.4,
      terjual: 78
    },
    {
      id: 6,
      nama: 'Minyak Kelapa Murni',
      harga: 40000,
      deskripsi: 'Minyak kelapa murni (VCO) hasil olahan tradisional untuk kesehatan',
      gambar: '/images/minyak-kelapa.jpg',
      kategori: 'minuman',
      rating: 4.6,
      terjual: 110
    }
  ];

  const categories = [
    { id: 'semua', label: 'Semua Produk', icon: '🎯' },
    { id: 'makanan', label: 'Makanan', icon: '🍪' },
    { id: 'minuman', label: 'Minuman', icon: '🍯' },
    { id: 'kerajinan', label: 'Kerajinan', icon: '🧺' }
  ];

  const filteredProduk = activeCategory === 'semua' 
    ? produk 
    : produk.filter(item => item.kategori === activeCategory);

  const formatRupiah = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount);
  };

  const getCategoryIcon = (kategori) => {
    const category = categories.find(cat => cat.id === kategori);
    return category ? category.icon : '🎁';
  };

  return (
    <section id="produk" className="py-20 bg-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-accent rounded-full mix-blend-multiply filter blur-3xl opacity-10 transform translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-secondary rounded-full mix-blend-multiply filter blur-3xl opacity-10 transform -translate-x-1/2 translate-y-1/2"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-blue-50 rounded-full px-6 py-2 mb-6">
            <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
            <span className="text-blue-700 text-sm font-semibold">PRODUK UNGGULAN</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Produk <span className="text-gradient">UMKM Desa</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Hasil karya terbaik warga desa dengan kualitas premium dan harga terjangkau
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex justify-center mb-12">
          <div className="inline-flex bg-gray-100 rounded-2xl p-2 shadow-inner">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`flex items-center px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
                  activeCategory === category.id
                    ? 'bg-white text-primary shadow-lg'
                    : 'text-gray-600 hover:text-primary hover:bg-white/50'
                }`}
              >
                <span className="mr-2 text-lg">{category.icon}</span>
                {category.label}
              </button>
            ))}
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProduk.map((item, index) => (
            <div 
              key={item.id} 
              className="group animate-slide-up"
              style={{animationDelay: `${index * 0.1}s`}}
            >
              <div className="bg-white rounded-3xl shadow-xl hover-lift overflow-hidden border border-gray-100 relative">
                {/* Product Image */}
                <div className="relative h-64 bg-gradient-to-br from-blue-50 to-green-50 overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="w-full h-full flex items-center justify-center">
                    <div className="text-6xl text-gray-400 group-hover:scale-110 transition-transform duration-500">
                      {getCategoryIcon(item.kategori)}
                    </div>
                  </div>
                  
                  {/* Badge */}
                  {item.badge && (
                    <div className="absolute top-4 left-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-bold text-white ${
                        item.badge === 'Terlaris' ? 'bg-red-500' :
                        item.badge === 'Premium' ? 'bg-purple-500' :
                        'bg-green-500'
                      }`}>
                        {item.badge}
                      </span>
                    </div>
                  )}

                  {/* Rating */}
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1 shadow-sm">
                    <span className="text-yellow-500 text-sm font-semibold flex items-center">
                      ⭐ {item.rating}
                    </span>
                  </div>

                  {/* Sold Count */}
                  <div className="absolute bottom-4 left-4 bg-black/70 text-white rounded-full px-3 py-1 text-xs">
                    🛒 {item.terjual} terjual
                  </div>
                </div>
                
                {/* Product Info */}
                <div className="p-6">
                  <div className="flex justify-between items-start mb-3">
                    <h3 className="text-xl font-bold text-gray-900 group-hover:text-primary transition-colors">
                      {item.nama}
                    </h3>
                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
                      {item.kategori}
                    </span>
                  </div>
                  
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed line-clamp-2">
                    {item.deskripsi}
                  </p>
                  
                  <div className="flex items-center justify-between">
                    <span className="text-2xl font-bold text-green-600">
                      {formatRupiah(item.harga)}
                    </span>
                    <button className="bg-primary text-white px-6 py-2 rounded-xl font-semibold hover:bg-blue-700 transition-colors duration-300 shadow-md hover:shadow-lg">
                      Beli Sekarang
                    </button>
                  </div>
                </div>

                {/* Hover Effect Border */}
                <div className="absolute inset-0 rounded-3xl border-2 border-transparent group-hover:border-primary/20 transition-all duration-300 pointer-events-none"></div>
              </div>
            </div>
          ))}
        </div>

        {filteredProduk.length === 0 && (
          <div className="text-center py-16">
            <div className="text-8xl mb-4 text-gray-300">📦</div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-2">Tidak ada produk</h3>
            <p className="text-gray-600">Tidak ada produk dalam kategori ini.</p>
          </div>
        )}

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href="#login"
            className="inline-flex items-center bg-gradient-primary text-white px-8 py-4 rounded-2xl font-bold hover-lift shadow-2xl transition-all duration-300"
          >
            <span>Lihat Semua Produk</span>
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProdukSection;